@if (authConfig.IsAdministrator) {
  <admin-dashboard></admin-dashboard>
}

@if (authConfig.IsArtist) {
  <artist-dashboard></artist-dashboard>
}

@if (authConfig.IsGallery || authConfig.IsGalleryStaff) {
  <app-gallery-dashboard></app-gallery-dashboard>
}



